import SectionViewContent from './SectionViewContent';
import {type Section} from './types';

type SectionViewProps = {
  section: Section;
  paragraphName: string | number;
};

function SectionView({section, paragraphName}: SectionViewProps) {
  return (
    <div>
      <h2 className="mb-4 font-bold text-xl">{`${paragraphName}. ${section.title}`}</h2>
      <div className="flex flex-col gap-1">
        {section.items.map((item, index) => (
          <SectionViewContent
            item={item}
            key={`section-static-${index}`}
            paragraphName={paragraphName}
          />
        ))}
      </div>
    </div>
  );
}

export default SectionView;
